<template>
  <div>
    <h2 id="bookingHeading">{{ $t('Book a meeting with us') }}</h2>
    <error-container v-if="bookingErrors.length > 0" :type="'booking'"></error-container>
    <service-select></service-select>
    <div class="section-separator section-separator--small-margin"></div>
    <meeting-type v-if="showBranchSelect"></meeting-type>
    <div class="section-separator section-separator--small-margin" v-if="showBranchSelect"></div>
    <comment-section v-if="showBranchSelect"></comment-section>
  </div>
</template>

<script>
import ErrorContainer from '../components/ErrorContainer.vue'
import ServiceSelect from '../components/ServiceSelect.vue'
import MeetingType from '../components/MeetingType.vue'
import CommentSection from '../components/Comment.vue'
import { mapState, mapActions } from 'pinia'
import { useBookingStore } from '../store'
export default {
  name: 'BookingView',
  data() {
    return {
      pageLang: 'Language',
    }
  },
  components: {
    ServiceSelect,
    MeetingType,
    CommentSection,
    ErrorContainer,
  },
  computed: {
    ...mapState(useBookingStore, ['services', 'groupValue', 'appCountry', 'showBranchSelect', 'bookingErrors']),
  },
  watch: {},
  methods: {
    ...mapActions(useBookingStore, ['getServices', 'setCustomerType']),
  },
}
</script>
